import { NetworkAdapter } from '@alveon/shared/platform/types';

export const webNetworkAdapter: NetworkAdapter = {
  async isOnline(): Promise<boolean> {
    return navigator.onLine;
  },
  onNetworkChange(callback: (isOnline: boolean) => void): () => void {
    const handleOnline = () => callback(true);
    const handleOffline = () => callback(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }
};

